var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"redictPage-body"},[_vm._v("\n\t页面加载中,请稍等...\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }